<script lang="ts" setup>
import { AppLogoDomain } from '@shared/ui/logos'

defineOptions({
  name: 'ClassroomHeader',
})
</script>

<template>
  <header class="classroom-header">
    <AppLogoDomain />
  </header>
</template>

<style scoped lang="scss" src="./ClassroomHeader.scss" />
